import { getShopRendererApiUrl } from '@fourthwall/env';
import { ApiBase } from '../ApiBase';
class ShopRendererNavigationApiClientModel extends ApiBase {
    constructor() {
        super(...arguments);
        this.createNavigationLink = (params, body) => {
            return this.post(`/v2/shops/${params.shop_id}/navigations/${params.navigation_id}/links`, body);
        };
        this.updateNavigationLink = (params, body) => {
            return this.put(`/v2/shops/${params.shop_id}/navigations/${params.navigation_id}/links/${params.link_id}`, body);
        };
        this.reorderNavigationLink = (params, body) => {
            return this.post(`/shops/${params.shop_id}/navigations/${params.navigation_id}/links/${params.shop_navigation_link_id}/reorder`, body);
        };
        this.deleteNavigationLink = (params) => {
            return this.delete(`/v2/shops/${params.shop_id}/navigations/${params.navigation_id}/links/${params.link_id}`);
        };
    }
}
export const ShopRendererNavigationApiClient = new ShopRendererNavigationApiClientModel(getShopRendererApiUrl('api'));
